import { render, staticRenderFns } from "./formelement_text.vue?vue&type=template&id=4c496aae&"
import script from "./formelement_text.vue?vue&type=script&lang=js&"
export * from "./formelement_text.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports